import React, { Component } from 'react'
import { DropdownButton, MenuItem }from 'react-bootstrap'

export default class ActionBar extends Component {

  render () {

    const options = [{id: "min_date" , name:  "Fecha ASC"},{id: "max_date" , name:  "Fecha DESC"}, {id: "min_title" , name:  "Título ASC"}, {id: "max_title" , name:  "Título DESC"} ]

    const { onChangeOrder, order } = this.props

    let title_order = order ? order.name : "Ordenar Por"

    return (
    	<div className="action-bar bar-news">
    		<div className="bar-options">
          <DropdownButton title={title_order} id="dropdown-order" onSelect={ onChangeOrder }>
            {options.map((item, index) =>
              <MenuItem className="div-option" eventKey={item} key={index}>{item.name}</MenuItem>
            )}
          </DropdownButton> 
	      </div>
	      <div className="bar-divisor hidden-xs">
	      </div>  
    	</div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Sections/News/ActionBar/index.js